import Api from '@/services/Api'

export default {
  getSalesChannels () {
    return Api().get('sales-channels').then(function (response) {
      return (response.data)
    })
  },
  get () {
    return Api().get('sales-channels').then(function (response) {
      return (response)
    })
  },
  getById(id) {
    return Api().get(`sales-channels/${id}`).then(function (response) {
      return (response)
    })
  },
  add(newSalesChannel) {
    return Api().post('sales-channels', newSalesChannel).then(function (response) {
      return (response)
    })
  },
  update(data) {
    return Api().put(`sales-channels/${data.id}`, data).then(function (response) {
      return (response)
    })
  },
  partialUpdate(id, data) {
    return Api().patch(`sales-channels/${id}`, data).then(function (response) {
      return (response)
    })
  }
}